import React, { Fragment } from 'react';
import Navbar from 'components/@layout/NavBar';
import AppBar from 'components/@layout/AppBar';
import AddCreateButton from 'components/@common/Buttons/AddCreateButton';
import useStore from 'store';
import { useTranslation } from 'react-i18next';
import { ModuleProps } from 'types';
import WithPrivilegedUser from 'components/@layout/WithPrivilegedUser';
import Config from 'config';
import { AlertVariant } from 'types/enums';
import BaseClassroomModal from 'components/ClassroomsModule/Classrooms/modals/BaseClassroomModal';
import {
  ClassroomModalVariant,
  ClassroomModalRouteAction
} from 'components/ClassroomsModule/types';
import ClassroomOptionsMenu from 'components/ClassroomsModule/Classrooms/components/ClassroomsOptionsMenu';

const { privilegesGroups } = Config;

type HeaderBarProps = ModuleProps & {
  admin?: boolean;
  setLoading: (value: boolean) => void;
};

export const HeaderBar: React.FC<HeaderBarProps> = ({ setLoading, admin, ...props }) => {
  const [, { openFullModal, closeModal, openAlert }] = useStore();
  const { t } = useTranslation(props.id);

  const handleClose = React.useCallback(
    (success: boolean) => {
      closeModal();
      if (success) {
        openAlert({
          variant: AlertVariant.SUCCESS,
          title: t('Class Created'),
          text: t('You successfully created your class.'),
          onClose: () => window.location.reload() //TODO: it would be better to make this work without a page reload
        });
      }
    },
    [openAlert, t, closeModal]
  );

  const handleOpenModal = (): void => {
    openFullModal({
      title: t('Create Class'),
      body: (
        <BaseClassroomModal
          handleClose={handleClose}
          classroomModalView={ClassroomModalVariant.CREATE}
        />
      ),
      routeAction: ClassroomModalRouteAction.CREATE_CLASSROOM
    });
  };

  return (
    <Fragment>
      <AppBar {...props}>
        <WithPrivilegedUser privileges={privilegesGroups.createClassroom}>
          <AddCreateButton onClick={handleOpenModal}>{t('Create Class')}</AddCreateButton>
          <ClassroomOptionsMenu admin={admin} setLoading={setLoading} {...props} />
        </WithPrivilegedUser>
      </AppBar>
      <Navbar {...props}></Navbar>
    </Fragment>
  );
};

export default HeaderBar;
